import { render, staticRenderFns } from "./multimedia-grand-challenge-submissions.vue?vue&type=template&id=2b9fb5dc&scoped=true"
import script from "./multimedia-grand-challenge-submissions.vue?vue&type=script&lang=js"
export * from "./multimedia-grand-challenge-submissions.vue?vue&type=script&lang=js"
import style0 from "./multimedia-grand-challenge-submissions.vue?vue&type=style&index=0&id=2b9fb5dc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b9fb5dc",
  null
  
)

export default component.exports